module.exports = __webpack_public_path__ + "static/img/ck.a734ef78.svg";